@if (mode !== SIGNUPMODES.GUEST_REVIEW) {
  <button
    type="button"
    class="ficon-arrow-left back-btn"
    role="button"
    [attr.aria-label]="'common_back' | translate"
    (click)="onBack$.next(null)"
    [disabled]="submitting$ | async">
  </button>
}

<section [formGroup]="form" #content [class.student-signup]="!requiresAccountInfo">
  <h1 translate="sign-up-account-create-title"></h1>

  <div goRequiredFieldsNote></div>

  @if (infoKey) {
    <mat-form-field appearance="outline" class="half first-name-field" subscriptSizing="dynamic">
      <mat-label translate="sign-up-form-label-first-name"></mat-label>
      <input matInput formControlName="firstName" maxlength="40" data-cy="account-create-form-firstname" />
      @if (form.controls.firstName.hasError('required') || form.controls.firstName.hasError('whitespace')) {
        <mat-error
          translate="sign-up-form-validation-first-name-required"
          data-cy="account-create-form-firstname-required">
        </mat-error>
      }
      @if (form.controls.firstName.hasError('maxlength')) {
        <mat-error
          translate="sign-up-form-validation-first-name-maxlength">
        </mat-error>
      }
    </mat-form-field>
    <mat-form-field appearance="outline" class="half last-name-field" subscriptSizing="dynamic">
      <mat-label translate="sign-up-form-label-last_name"></mat-label>
      <input matInput formControlName="lastName" maxlength="40" data-cy="account-create-form-lastname" />
      @if (form.controls.lastName.hasError('required') || form.controls.lastName.hasError('whitespace')) {
        <mat-error
          translate="sign-up-form-validation-last-name-required"
          data-cy="account-create-form-lastname-required">
        </mat-error>
      }
      @if (form.controls.lastName.hasError('maxlength')) {
        <mat-error
          translate="sign-up-form-validation-last-name-maxlength">
        </mat-error>
      }
    </mat-form-field>
  }

  @if (requiresAccountInfo) {
    <mat-form-field appearance="outline" class="phone-number" subscriptSizing="dynamic">
      <mat-label translate="sign-up-form-label-phone-number"></mat-label>
      <input
        matInput
        formControlName="phoneNumber"
        autocomplete="tel"
        maxlength="25"
        data-cy="account-create-form-phone"
        class="fullstory-ignore" />
    </mat-form-field>
  }

  @if (requiresAccountInfo) {
    <mat-form-field appearance="outline" class="primary-use" subscriptSizing="dynamic">
      <mat-label translate="account-setup-primary-use"></mat-label>
      <mat-select
        formControlName="useType"
        data-cy="account-create-form-course-type"
        [placeholder]="'account-setup_select_one_placeholder' | translate"
        disableOptionCentering
        panelClass="offsetPanel">
        @for (type of useTypes$ | async; track type.use_type_id) {
          <mat-option
            [value]="type">
            {{ $any(type).name }}
          </mat-option>
        }
      </mat-select>
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
      @if (form.controls.useType.hasError('required')) {
        <mat-error
          translate="account-setup-error-required-primary-use"
          data-cy="account-create-form-course-type-required">
        </mat-error>
      }
    </mat-form-field>
  }

  @if (requiresAccountInfo) {
    <mat-form-field appearance="outline" class="role" subscriptSizing="dynamic">
      <mat-label translate="account-setup_your_role"></mat-label>
      <mat-select
        formControlName="jobRole"
        data-cy="account-create-form-role"
        [placeholder]="'account-setup_select_one_placeholder' | translate"
        disableOptionCentering
        panelClass="offsetPanel">
        @for (role of jobRoles$ | async; track role.name) {
          <mat-option
            [value]="role.name">
            {{ role.name }}
          </mat-option>
        }
      </mat-select>
      <mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
      @if (form.controls.jobRole.hasError('required')) {
        <mat-error
          translate="account-setup-error-required_role"
          data-cy="account-create-form-role-required">
        </mat-error>
      }
    </mat-form-field>
  }

  <button
    mat-flat-button
    color="warn"
    type="button"
    class="submit-btn"
    (click)="accountCreate$.next()"
    [disabled]="submitting$ | async"
    data-cy="account-create-form-create-btn"
    [focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}">
    {{
    ((submitting$ | async) ?
    'sign-up-form-creating-account' :
    'common_create-account') | translate
    }}
  </button>

  @if (errorMessage$ | async; as errorKey) {
    <mat-error
      [translate]="errorKey"
      (click)="resolveError(errorKey)">
    </mat-error>
  }
</section>
